import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  z-index: 10;
  left: 0;
  right: 0;
`;
